export default "__VITE_ASSET__DzWHXYno__"